export default __webpack_public_path__ + "static/media/day_close.1b1ade78.svg";